module.exports = __webpack_public_path__ + "static/media/playskills2ab639b0b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/categories/playskills2.svg
// module id = 1335
// module chunks = 0